// Référentiel du funnel de vente CRM360 — ordre des étapes + mapping des statuts.
// Source unique réutilisée par le rapport Funnel et l'écran d'import (signalement
// des statuts inconnus). CRM360 ne fournit que le statut COURANT : on reconstruit
// la cascade en « étape la plus avancée atteinte = statut courant » ; les perdus
// (Abandonné / Refusé) sont comptés à part (on ignore à quelle étape ils ont décroché).

// etape = position dans la cascade (4→8, après les 3 étapes AUTODOM97) ; cat = progress | perdu
const S = (code, etape, cat) => ({ code, etape, cat });
export const CRM360_STATUTS = [
  S('À qualifier',               4, 'progress'),
  S('À traiter',                 4, 'progress'),
  S('Traité (Ouvert)',           4, 'progress'),
  S('Traité (Relance planifiée)',4, 'progress'),
  S('Traité (RDV)',              5, 'progress'),
  S('Traité (Essai planifié)',   5, 'progress'),
  S('Traité (Essai effectué)',   5, 'progress'),
  S('Traité (Offre)',            6, 'progress'),
  S('Traité (Commande)',         7, 'progress'),
  S('Traité (Livraison)',        8, 'progress'),
  S('Traité (Abandonné)',     null, 'perdu'),
  S('Refusé',                 null, 'perdu'),
];

const norm = (s) => String(s || '').trim();
const BY_CODE = Object.fromEntries(CRM360_STATUTS.map(s => [norm(s.code).toLowerCase(), s]));
export const crm360StatutDef = (code) => BY_CODE[norm(code).toLowerCase()] || null;
export const isKnownCrm360Statut = (code) => !!crm360StatutDef(code);

// Étapes du funnel complet (1-3 AUTODOM97, 4-8 CRM360)
export const FUNNEL_STAGES = [
  { idx: 1, key: 'recus',          label: 'Leads reçus',                emoji: '📥', src: 'autodom' },
  { idx: 2, key: 'affectes',       label: 'Affectés (vendeur)',         emoji: '🧑‍💼', src: 'autodom' },
  { idx: 3, key: 'transmis',       label: 'Transmis à CRM360',          emoji: '🔄', src: 'autodom' },
  { idx: 4, key: 'pris_en_charge', label: 'CRM360 — Pris en charge',    emoji: '👤', src: 'crm360' },
  { idx: 5, key: 'engagement',     label: 'CRM360 — RDV / Essai',       emoji: '🚗', src: 'crm360' },
  { idx: 6, key: 'offre',          label: 'CRM360 — Offre',             emoji: '💶', src: 'crm360' },
  { idx: 7, key: 'commande',       label: 'CRM360 — Commande (vente)',  emoji: '✅', src: 'crm360' },
  { idx: 8, key: 'livraison',      label: 'CRM360 — Livraison',         emoji: '🚚', src: 'crm360' },
];

const pct = (n, d) => (d > 0 ? Math.round((n / d) * 1000) / 10 : 0);

// Construit le funnel à partir du payload backend :
//   { recus, affectes, transmis, crm360_par_statut: { '<statut>': n, ... } }
export function buildFunnel(payload = {}) {
  const counts = payload.crm360_par_statut || {};
  // Cumul progress par étape (etape4 = tous les progress, etape8 = livraison seule)
  const cumul = { 4: 0, 5: 0, 6: 0, 7: 0, 8: 0 };
  let perduAbandonne = 0, perduRefuse = 0;
  const aClasser = [];
  for (const [statut, nRaw] of Object.entries(counts)) {
    const n = Number(nRaw) || 0;
    const def = crm360StatutDef(statut);
    if (!def) { aClasser.push({ statut, n }); continue; }
    if (def.cat === 'perdu') {
      if (/refus/i.test(statut)) perduRefuse += n; else perduAbandonne += n;
    } else {
      for (let e = 4; e <= def.etape; e++) cumul[e] += n;
    }
  }

  const base = {
    recus: Number(payload.recus) || 0,
    affectes: Number(payload.affectes) || 0,
    transmis: Number(payload.transmis) || 0,
    pris_en_charge: cumul[4], engagement: cumul[5], offre: cumul[6], commande: cumul[7], livraison: cumul[8],
  };

  const total = base.recus;
  const stages = FUNNEL_STAGES.map((st, i) => {
    const count = base[st.key] || 0;
    const prev = i > 0 ? (base[FUNNEL_STAGES[i - 1].key] || 0) : count;
    return { ...st, count, pctPrev: i > 0 ? pct(count, prev) : 100, pctTotal: pct(count, total) };
  });

  return {
    stages,
    perdus: { abandonne: perduAbandonne, refuse: perduRefuse, total: perduAbandonne + perduRefuse },
    aClasser,
    // « vente » = Commande ; taux de conversion global = ventes / leads reçus
    ventes: base.commande,
    tauxConversion: pct(base.commande, total),
  };
}
